<template>
  <div class="scroll">
    <span class="scroll__line"></span>
    <span class="scroll__line"></span>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.scroll {
  display: none;
}

@include media-min($desktop-width) {
  .scroll {
    position: absolute;
    bottom: 150px;
    left: 60px;
    display: block;
    height: 41px;
    overflow: hidden;

    &__line {
      display: inline-block;
      width: 2px;
      height: 100%;
      border-radius: 2px;
      background-color: rgb(235, 29, 37);
      animation: scroll-line 2.5s ease;
      animation-delay: 0s;
      animation-iteration-count: infinite;

      &:not(:first-of-type) {
        margin-left: 8px;
        animation-delay: 0.5s;
      }
    }
  }
}

@keyframes scroll-line {
  0% {
    transform: translateY(-105%);
  }

  50% {
    transform: translateY(0);
  }

  99.99% {
    transform: translateY(100%);
  }

  100% {
    transform: translateY(-105%);
  }
}
</style>



// WEBPACK FOOTER //
// components/_UI/BaseScrollIcon.vue